import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress/nprogress";
import routes from "./routes";
import { isLogged } from "@/utils/auth/user";
import staticRoutes from "./staticRoutes";
import StorageService from "@/services/StorageService";
NProgress.configure({ showSpinner: false });

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_PATH,
  routes: [...routes, ...staticRoutes],
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkActiveClass: "active",
});

function redirectToLogin(next, routeTo) {
  // Pass the original route to the login component
  next({ name: "login", query: { redirectFrom: routeTo.fullPath } });
}

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  StorageService.store("previousRoute", routeFrom.name);
  // If this isn't an initial page load...
  if (routeFrom.name !== null) {
    // Start the route progress bar. This will on top of the screen.
    NProgress.start();
  }

  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  // If auth isn't required for the route, just continue.
  if (!authRequired) {
    if (routeTo.name === "login" && isLogged()) {
      return next({ name: "dashboard" });
    }
    return next();
  }

  // If auth is required and the user is logged in...
  const token = isLogged();
  if (token) {
    return next();
  } else {
    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    return redirectToLogin(next, routeTo);
  }
});

// When each route is finished evaluating...
router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
